export const RFA_TYPE_LIST = ['RFMA'];

export const RFA_PROG_LIST = [47];

export const RFA_COMPLETED_STATUSES = ['approved'];
